<script lang="ts">
    import LogoLoader from "../../public/icons/logo_loader.svelte";



</script>


<div class="loading-screen"> 
        <!-- <LightningLoader width={"10%"} height={"10%"} fill={"#FFF"}/> -->
        <div>
            <LogoLoader/>
        </div>

</div>



<style>
.loading-screen {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    aspect-ratio: 16/9;
    overflow: hidden;
    position: relative;
    font-size: 24px;
    padding: 5%;
    background-color: #121A24;
}
.loading-screen div {
    width: 50vw;
}

.error-header {
    color: var(--primary-color);
}



</style>